<template>
  <div class="box5-container">
    <div class="content">
      <div class="box5_con">
        <div class="left_num">
          <div class="num_one">{{itemData.total}}<span>{{$t("home.box5.text1")}}</span></div>
          <div class="num_one">{{itemData.program}}<span>{{$t("home.box5.text2")}}</span></div>
        </div>
        <div class="right_video">
          <div v-if="itemData.url" class="video">
            <template  v-if="itemData.type==2">
              <img :src="itemData.url"/>
            </template>
            <template  v-else>
            <video
              :src="itemData.url"
              controls
              loop
              autoplay
              width="100%"
              height="100%"
            ></video>
            </template>
          </div>
          <div class="no_video" v-else>{{$t("home.box5.text3")}}</div>
        </div>
      </div>
      
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box5', 
  props: {
    itemData: {
      type: Object,
      required: true,
      default: function () {
        return {
          total: 0,
          program: 0,
          url: []
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang='less'>
.box5-container {
  width: 100%;
  height: 100%;
  position: relative;
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 15px 0;
  }
}
.box5_con{
  display:flex;
  width:100%;
  height:100%;
  position: relative;
  .left_num{
    height:100%;
    width:125px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top:-5px;
    .num_one{
      color:#70b1f0;
      font-size: 28px;
      font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      font-style: normal;
      text-align: center;
      margin-top:10px;
      span{
        margin-top:2px;
        display:block;
        color:#fff;
        font-size: 12px;
        font-family: Arial;
      }
    }
  }
  .right_video{
    left:0;
    right:0;
    top:0;
    bottom:0;
    height:100%;
    position: absolute;
    padding-left: 125px;;
    .video{
      width:100%;
      height:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      overflow: hidden;
      video{
        height:100%;
        width:100%;
        object-fit:fill
      }
      img{
        height:100%;
        width:auto;
      }
    }
    .no_video{
      height:100%;
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:18px;
      color:#fff;
      background: #3f3a32;
    }
  }
}
</style>
